import React from 'react';
import { useToggle } from 'usehooks-ts';
import { useParams } from 'react-router-dom';

import { Downloadble } from '../../downloadable';
import { DownloadReportFeedbackAsync } from '../../../../services/event-reports';

export const DownloadableReport: React.FC<{ fileName: string }> = ({
  fileName
}) => {
  const { eventId, detailId } = useParams();

  const [isLoading, toggleIsLoading] = useToggle(false);

  const onClick = async () => {
    toggleIsLoading();
    try {
      await DownloadReportFeedbackAsync(parseInt(eventId!), fileName, [
        detailId
      ]);
    } catch (err) {
      console.error(err);
    } finally {
      toggleIsLoading();
    }
  };

  return (
    <Downloadble
      text={'Report'}
      icon={'assignment'}
      bgColor={'#707070'}
      disabled={isLoading}
      // onClick={onClick}
      downloadText={isLoading ? 'Downloading' : 'Download'}
    />
  );
};
